import React from 'react';
import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import RichEditor from './Shared/RichEditor';
import DOMPurify from 'dompurify';

const AdditionalNotes = ({index, id, description, onChange, isEditMode, isFormLive}) => {
    return (
        <Box>
            {isEditMode
                ? <RichEditor value={description} onChange={onChange} id={id} index={index} isEditMode={isEditMode}
                              isFormLive={isFormLive}/>
                : <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(description)}}/>
            }
        </Box>
    );
};

AdditionalNotes.propTypes = {
    id: PropTypes.string,
    description: PropTypes.string,
    index: PropTypes.number,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormLive: PropTypes.bool,
    readOnly: PropTypes.bool
};

export default AdditionalNotes;